<template>
    <div>
      <Head>
        <title>{{course.title}} - Ireland Course</title>
        <link rel="canonical" :href="'https://backtoworkconnect.ie/course/'+course.alias" />
        <meta head-key="description" name="description" :content="metaDescription" />
      </Head>

      <v-container class="lighten-5" style="padding-bottom:65px">
        <BackButton></BackButton>
        <v-card elevate>
            <v-card-title class="course-header">
                <span class="course-header__title text-h5 text-md-h4">{{course.title}}</span>
                <div class="course-header__actions" v-if="canApply()">
                    <v-icon v-if="!isFavorite" @click="triggerAddFavorite()" class="mr-sm-3" color="primary">mdi-heart-outline</v-icon>
                    <v-icon v-if="isFavorite" @click="triggerDelFavorite()" class="mr-sm-3" color="primary">mdi-heart</v-icon>
                    <!-- On phones the fixed bottom bar already carries this action. -->
                    <v-btn v-if="!isApplied" @click="triggerApply()" color="primary" class="hidden-xs-only"><v-icon left>mdi-send</v-icon>Contact the College</v-btn>
                    <v-btn v-if="isApplied" color="secondary" class="hidden-xs-only"><v-icon left>mdi-check</v-icon>Information requested</v-btn>
                </div>
            </v-card-title>
            <v-card-text>
                <v-card outlined elevation="2" shaped class="hidden-md-and-down" style="width:400px;float:right">
                    <v-card-title class="bottom-border-purple mb-3 text-h6">Company Information</v-card-title>
                    <v-card-subtitle class="mt-3"><span class="text-h6">{{course.organization.name}}</span></v-card-subtitle>
                    <v-card-text>
                        <v-img :src="baseurl + '/img/' + course.organization.photo_path"></v-img>
                    </v-card-text>
                    <v-card-actions class="justify-center">
                        <a :href="baseurl+'/organization/'+course.organization.alias"><v-btn outlined primary>View Company Details</v-btn></a>
                    </v-card-actions>
                </v-card>
                <v-container class="detail-body">
                    <v-row>
                        <v-col cols="6" sm="6" md="12" lg="4">
                            <span class="text-lg-h6"><v-icon left>mdi-shape</v-icon>Category</span>
                            <p v-html="course.category.title"></p>
                        </v-col>
                        <v-col cols="6" sm="6" md="12" lg="4" v-if="course.region">
                            <span class="text-lg-h6 text-md-body-1"><a :href="getUrl()" target="_blank"><v-icon left>mdi-map</v-icon></a>Location</span>
                            <p>{{ locationLabel }} <a :href="getUrl()" target="_blank"><v-icon>mdi-open-in-new</v-icon></a></p>
                        </v-col>
                        <v-col cols="6" sm="6" md="12" lg="4">
                            <span class="text-lg-h6"><v-icon left>mdi-license</v-icon>Awarding Body</span>
                            <p v-html="course.awarding_body"></p>
                        </v-col>
                        <v-col
                            cols="6"
                            sm="6"
                            md="12"
                            lg="4"
                            v-if="course.duration"
                        >
                            <span class="text-lg-h6"><v-icon left>mdi-calendar</v-icon>Duration</span>
                            <p>{{ course.duration }}</p>
                        </v-col>
                        <v-col
                            cols="6"
                            sm="6"
                            lg="4"
                            md="12" v-if="course.timetable"
                        >
                            <span class="text-lg-h6"><v-icon left>mdi-calendar</v-icon>Timetable</span>
                            <p>{{ course.timetable }}</p>
                        </v-col>
                        <v-col
                            cols="6"
                            sm="6"
                            lg="4"
                            md="12" v-if="course.start_date"
                        >
                            <span class="text-lg-h6"><v-icon left>mdi-calendar</v-icon>Start Date</span>
                            <p>{{ course.start_date }}</p>
                        </v-col>
                        <v-col
                            cols="6"
                            sm="6"
                            md="4"
                            v-if="course.contact_email"
                        >
                            <span class="text-lg-h6"><v-icon left>mdi-email</v-icon>Email</span>
                            <p>{{ course.contact_email }}</p>
                        </v-col>
                        <v-col
                            cols="6"
                            sm="6"
                            md="4" v-if="course.contact_phone"
                        >
                            <span class="text-lg-h6"><v-icon left>mdi-phone</v-icon>Phone</span>
                            <p>{{ course.contact_phone }}</p>
                        </v-col>

                    </v-row>
                    <v-row v-if="course.description">
                        <v-col md="12">
                            <span class="text-h6">Description</span>
                            <div class="rich-text" v-html="convertNR(course.description)"></div>
                        </v-col>
                    </v-row>
                    <v-row class="top-border-purple" v-if="course.course_content || course.learning_outcomes || course.entry_requirements">
                        <v-col cols="12" sm="12">
                            <p class="text-h5">Other Information</p>
                        </v-col>
                    </v-row>
                    <v-row v-if="course.course_content">
                        <v-col md="12">
                            <span class="text-h6">Course Content</span>
                            <div class="rich-text" v-html="convertNR(course.course_content)"></div>
                        </v-col>
                    </v-row>
                    <v-row v-if="course.entry_requirements">
                        <v-col md="12">
                            <span class="text-h6">Entry Requirements</span>
                            <div class="rich-text" v-html="convertNR(course.entry_requirements)"></div>
                        </v-col>
                    </v-row>
                    <v-row v-if="course.learning_outcomes">
                        <v-col md="12">
                            <span class="text-h6">Learning Outcomes</span>
                            <div class="rich-text" v-html="convertNR(course.learning_outcomes)"></div>
                        </v-col>
                    </v-row>
                </v-container>
            </v-card-text>

        </v-card>  
        <v-card outlined elevation="24" shaped class="hidden-lg-and-up mt-5" >
            <v-card-title class="bottom-border-purple mb-3 text-h6">Company Information</v-card-title>
                    <v-card-subtitle class="mt-3"><span class="text-h6">{{course.organization.name}}</span></v-card-subtitle>
                    <v-card-text>
                        <v-img :src="baseurl + '/img/' + course.organization.photo_path"></v-img>
                    </v-card-text>
                    <v-card-actions class="justify-center">
                        <a :href="baseurl+'/organization/'+course.organization.alias"><v-btn outlined primary>View Company Details</v-btn></a>
                    </v-card-actions>
            </v-card> 
      </v-container>
      <CourseApplyDialog 
        v-if="auth.user && !isApplied" 
        :user = "auth.user" 
        :dialog="applyDialog" 
        :course="course" 
        @close="applyDialog = false" 
        :baseurl="baseurl">
        </CourseApplyDialog>
      <v-app-bar class="fixedFooter"
  elevation="4"
        v-if="prevurl || !isApplied"
>
            <v-btn v-if="prevurl" :href="prevurl">Back</v-btn><v-spacer></v-spacer>
            <template v-if="canApply()">
                <v-btn @click="triggerApply()" v-if=" !isApplied" ><v-icon class="mr-3">mdi-plane</v-icon>Contact the College</v-btn>
                <v-btn v-if="isApplied" color="secondary" ><v-icon class="mr-3">mdi-check</v-icon>Information requested</v-btn>
            </template>
        </v-app-bar>
    </div>
</template>
<script>
  import { Head } from '@inertiajs/inertia-vue'
  import Layout from '@/Shared/VuetifyLayout'
  import CourseApplyDialog from '@/Shared/CourseApplyDialog'
  import axios from 'axios'
  
  import BackButton from '@/Shared/BackButton'

  export default {
    props: {
      course: Object,
      auth: Object,
      state: String,
      isFavorite: Boolean,
      isApplied: Boolean,
      baseurl: String,
      prevurl: String,
      metaDescription: String,
    },
    components: {
      Head,
      BackButton,
      CourseApplyDialog
    },
    layout: Layout,
    computed: {
        locationLabel() {
            const parts = [this.course.address, this.course.city, this.course.postal_code, this.course.region]
                .map(part => (part == null ? '' : String(part).trim()))
                .filter(part => part !== '');
            // City and region are often the same word (Dublin, Dublin).
            return parts.filter((part, i) => i === 0 || part.toLowerCase() !== parts[i - 1].toLowerCase()).join(', ');
        },
    },
    data() {
        return {
            applyDialog: false,
        }
    },
    watch: {
    },
    created() {
    },
    methods: {
        convertNR(str) {
            if (!str) return '';

            // Editor content is already HTML; turning its newlines into <br/>
            // doubles the spacing. Only genuinely plain text needs converting.
            if (/<[a-z][\s\S]*>/i.test(str)) return str;

            return str.replace(/\r\n?/g, '\n').replace(/\n/g, '<br/>').replace(/\t/g, '&nbsp;&nbsp;')
        },
        canApply() {
            if (!this.auth.user || (this.auth.user.roles.includes('admin') || this.auth.user.roles.includes('user')))
                return true;
            else
                return false;
        },
        getUrl() {
            return 'https://www.google.com/maps/search/?api=1&query='+encodeURIComponent(this.course.address +','+this.course.region)

        },
      triggerApply() {
        /*console.log('trigger apply');
        if (!this.auth.user)
            this.$parent.$emit('toggleComponentLogin','courseapply-'+this.course.id);
        else if (this.course.course_link)
            window.open(window.location + '/apply')
        else
            this.applyDialog = true;*/

        window.open(this.baseurl+'/course/'+this.course.alias+'/apply');
        //window.open(window.location + '/apply');
            
      },
      triggerAddFavorite() {
        console.log('trigger addfavorite');
        if (!this.auth.user)
            this.$parent.$emit('toggleComponentLogin','courseaddfavorite-'+this.course.id);
        else
            this.$inertia.get(this.baseurl+"/user/course/addfavorite/"+this.course.id)
      },
      triggerDelFavorite() {
        console.log('trigger delfavorite',this.auth.user,this.baseurl+"/user/course/delfavorite/"+this.course.id);
        if (!this.auth.user)
          this.$parent.$emit('toggleComponentLogin','coursedelfavorite-'+this.course.id);
        else
            this.$inertia.get(this.baseurl+"/user/course/delfavorite/"+this.course.id);
      }
    },
  }
  </script>
  
  <style>
    .course-header {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        gap: 8px 16px;
        word-break: normal;
        overflow-wrap: anywhere;
    }
    .course-header__title {
        flex: 1 1 240px;
        min-width: 0;
        line-height: 1.25 !important;
    }
    .course-header__actions {
        display: flex;
        align-items: center;
        margin-left: auto;
    }
    @media (max-width: 599px) {
        .course-header {
            align-items: flex-start;
        }
        .course-header__actions {
            margin-top: 3px;
        }
        .v-snack__wrapper {
            min-width: 0 !important;
            max-width: calc(100vw - 16px) !important;
        }
    }
    .fixedFooter {
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100%;
    color: white;
    text-align: center;
    }
    </style>